<ng-container
  *ngTemplateOutlet="
    imageTemplate || defaultImageTemplate;
    context: { $implicit: context() }
  "
></ng-container>

<ng-template #defaultImageTemplate let-context>
  @if (context.src) {
    <img [src]="context.src" [alt]="context.alt" [class]="context.class" />
  }
</ng-template>
